import React, { useEffect, useState } from "react";
import { Link } from "@material-ui/core";
import { getFilePublicURL, getKeyFilename } from "../../../utils/fileUtils";

export const MarkdownLink = ({
  handleClose,
  href,
  callBack,
  children,
  setVideoId,
  kbFiles,
  kbMedia,
  openKbMedia,
}) => {
  const safeHandleClose = handleClose || (() => {});
  const [mode, setMode] = useState("url");
  const [param, setParam] = useState("");

  useEffect(() => {
    if (!href) return;
    const params = href.match(/^(tour|video|custom|kbfile|kbmedia)\/(.+)/i);

    if (params?.length === 3) {
      setMode(params[1].toLowerCase());
      setParam(params[2]);
    } else {
      setMode("url");
      setParam("");
    }
  }, [href]);

  const handleClick = (e) => {
    e.preventDefault();

    switch (mode) {
      case "video":
        setVideoId(param);
        safeHandleClose();
        break;
      case "tour":
        window.Produktly.startTour({ tourId: param });
        safeHandleClose();
        break;
      case "custom":
        callBack();
        break;
      case "kbfile": {
        const decoded = decodeURIComponent(param);
        const match =
          kbFiles?.find(
            (obj) => getKeyFilename(obj.key) === decoded && obj.key
          ) || null;

        if (match?.key) {
          const url = getFilePublicURL(match.key);
          window.open(url, "_blank");
        }
        safeHandleClose();
        break;
      }
      case "kbmedia": {
        const decoded = decodeURIComponent(param);
        const match =
          kbMedia?.find(
            (obj) => getKeyFilename(obj.key) === decoded && obj.key
          ) || null;

        if (match?.key) {
          const url = getFilePublicURL(match.key);

          if (openKbMedia) {
            openKbMedia({
              url,
              title: param,
            });
          } else {
            window.open(url, "_blank");
          }
        }
        safeHandleClose();
        break;
      }
      default:
        window.open(href, "_blank");
        safeHandleClose();
        break;
    }
  };

  return (
    <Link
      underline="none"
      style={{ fontWeight: "bold" }}
      component="button"
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};
